import { createSelector } from '@reduxjs/toolkit';
import { EParkingType } from '../../../../packages/JsonQuery';
import { selectParkingTypes } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Наземная', value: EParkingType.Ground },
  { label: 'Многоуровневая', value: EParkingType.Multilevel },
  { label: 'Подземная', value: EParkingType.Underground },
];

export const selectParkingFilter = createSelector(selectParkingTypes, value => ({
  label: 'Парковка',
  value: value?.length ? (value as EParkingType[]) : [null],
  options: OPTIONS,
}));
